var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantPot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.34867C10.3001 7.22496 9.16153 6.90395 8.35107 6.1204C7.22663 5.03328 7.02363 3.33596 7.0087 2.36242C7.00188 1.91797 7.35697 1.5749 7.81683 1.58164C8.82413 1.5964 10.5803 1.79316 11.7047 2.88028C11.8599 3.03028 11.9975 3.19191 12.1195 3.36165C12.2415 3.19191 12.3791 3.03028 12.5342 2.88028C13.6587 1.79316 15.4148 1.5964 16.4221 1.58164C16.882 1.5749 17.2371 1.91797 17.2303 2.36242C17.2153 3.33596 17.0123 5.03328 15.8879 6.1204C15.0082 6.97087 13.7419 7.27642 12.75 7.37622V11.0002H19C19.5523 11.0002 20 11.4479 20 12.0002V13.0002C20 13.5525 19.5523 14.0002 19 14.0002H18L17.1095 21.1242C17.0469 21.6246 16.6215 22.0002 16.1172 22.0002H7.88278C7.37846 22.0002 6.95306 21.6246 6.8905 21.1242L6 14.0002H5C4.44772 14.0002 4 13.5525 4 13.0002V12.0002C4 11.4479 4.44772 11.0002 5 11.0002H11.25V7.34867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantPot);
export default __webpack_public_path__ + "static/media/plant-pot.424027b168e63c92f988f3f698882555.svg";
export { ForwardRef as ReactComponent };